import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import {
  getValuesForOutputContext,
  OutputInfo,
  outputInfoStoreToken,
} from '../../core/h3ml/state/output-info';
import { EventTrackingService } from '../../shared/event-tracking/event-tracking.service';

// https://github.com/ng-packagr/ng-packagr/issues/696#issuecomment-373487183
// @dynamic
@Component({
  selector: 'h3-nestable-output',
  templateUrl: './nestable-output.component.html',
  providers: [
    EventTrackingService,
    {
      provide: outputInfoStoreToken,
      deps: [NestableOutputComponent],
      useFactory: (self: NestableOutputComponent) => self.outputInfoStore,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NestableOutputComponent implements OnInit {
  @Input({ required: true }) outputInfoStore!: Store<OutputInfo>;
  @Input() withinTagEditor = false;

  constructor(private eventTrackingService: EventTrackingService) {}

  ngOnInit() {
    // Not needed for root-level outputs, where this context is already set in
    // `output.component.ts`. But for nested outputs, we need to override e.g.
    // the video's output_id with our output_id.
    this.eventTrackingService.addContext({
      ...getValuesForOutputContext(this.outputInfoStore.state().output),
      sub_bucket: this.withinTagEditor ? 'annotation' : 'non_annotation',
    });
  }
}
